const initialState = {
  openSideMenu: false,
  sideMenuKey: "",
  sideMenuScope: "",
};

export const uiReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "open-side-menu":
      return {
        ...state,
        openSideMenu: true,
        sideMenuKey: payload.key,
        sideMenuScope: payload.scope,
      };

    case "close-side-menu":
      return {
        ...state,
        openSideMenu: false,
        sideMenuKey: "",
        sideMenuScope: "",
      };

    default:
      return state;
  }
};

export const openSideMenu = (key, scope) => (dispatch) => {
  return dispatch({ type: "open-side-menu", payload: { key, scope } });
};
export const closeSideMenu = () => (dispatch) => {
  return dispatch({ type: "close-side-menu" });
};
